import type { ProductRatePlan } from '../../customerCenter/serviceOverview/types';
import { isFreeTrialLevel } from '../termedLevel/freeTrialLevel';
import { isIntegratedOfferLevel } from '../termedLevel/integratedOfferLevel';
import type { TermedProductInfo } from '../termedLevel/redux/types';

export function hasBookableRatePlans(ratePlans: ProductRatePlan[] | undefined): boolean {
    if (ratePlans === undefined) {
        return false;
    }
    return ratePlans.some(isRatePlanBookable);
}

export function getDefaultBookableLevel(bookableLevels: string[], fallbackLevels: string[] = []): string | undefined {
    return bookableLevels[0] ?? fallbackLevels[0];
}

export function isRatePlanBookable(ratePlan: Pick<ProductRatePlan, 'legacy' | 'level'>): boolean {
    return !isLegacy(ratePlan) && !isFreeTrial(ratePlan) && !isIntegratedOffer(ratePlan);
}

export function isFreeTrial(ratePlan: Pick<ProductRatePlan, 'level'>): boolean {
    return isFreeTrialLevel(ratePlan.level);
}

export function isIntegratedOffer(ratePlan: Pick<ProductRatePlan, 'level'>): boolean {
    return isIntegratedOfferLevel(ratePlan.level);
}

export function isLegacy(ratePlan: Pick<ProductRatePlan, 'legacy'> | undefined): boolean {
    return Boolean(ratePlan?.legacy);
}

/**
 * Checks if a product is marked as legacy at the product level
 * @param product The product to check for legacy status
 * @returns true if the product is marked as legacy, false otherwise
 */
export const isProductLegacy = (product?: TermedProductInfo): boolean => {
    if (!product) {
        return false;
    }

    // Use the legacy flag at the product level
    return product.legacy === true;
};
